import React, { useEffect, useState } from 'react';
import { Card, CardHeader, CardContent, Stack, IconButton, Tooltip, Typography, TextField, Grid, FormHelperText, Box, Button } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { set } from 'lodash';
import { getBeneficiaryUploadedImage } from '../APIs/action';
import { toast } from 'react-toastify';
import { calculateAgesAndFlags } from '../AddNewBeneficiary';

const EditCard = ({
  EntityData,
  isEditing,
  errors,
  handleChange,
  handleEditClick,
  handleImageChange,
  newImage,
  index
}) => {
  const [ showImage, setShowImage] = useState(null);
  const [ pancardImg, setPancardImg] = useState(null);
  const [ age, setAge] = useState(null);
  const getBenficiaryPancardImage = async () => {
    const { data, error, message } = await getBeneficiaryUploadedImage(EntityData.id);
    if (!error) {
      setPancardImg(data.pancard_image);
    } else {
      toast.error(message)
    }   
  };
  const showImageUploadedImage = () => {
    getBenficiaryPancardImage();
    setShowImage(true);
  }
  useEffect(() => {
    if (EntityData.date_of_birth) {
        const { age, ageFlag } = calculateAgesAndFlags([EntityData.date_of_birth])[0];
        setAge(age);
    }
  }, [EntityData.date_of_birth]);
  return (
    <Card sx={{ my: '1rem' }} key={index}>
      <CardHeader
        title={EntityData.first_name}
        sx={{ backgroundColor: '#f5f5f5' }}
        action={
          <Stack direction='row' spacing={2}>
            <Tooltip title={isEditing ? 'Save' : 'Edit'}>
              <IconButton color='primary' onClick={(e) => handleEditClick(e, EntityData)}>
                {isEditing && (
                  <CheckIcon sx={{ color: 'green' }} />
                )}
              </IconButton>
            </Tooltip>
          </Stack>
        }
      />
      <CardContent>

        {/* Phone and Email */}
        <Grid container>
          <Grid item xs={4} md={2} alignContent='center'>
            <Typography variant='h6' fontSize={15}>
              First Name
            </Typography>
          </Grid>
          <Grid item xs={8} md={4} alignContent='center'>
            <TextField
              disabled={!isEditing}
              label='First Name'
              name='first_name'
              value={EntityData.first_name}
              onChange={handleChange}
              fullWidth
              margin='normal'
              error={!!errors.first_name}
            />
            {errors.first_name && <FormHelperText>{errors.first_name}</FormHelperText>}
          </Grid>
          {/* First Name */}
          
          <Grid item xs={4} md={2} alignContent='center' sx={{ px: {md: 4} }}>
            <Typography variant='h6' fontSize={15}>
              Last Name
            </Typography>
          </Grid>
          <Grid item xs={8} md={4} alignContent='center'>
            <TextField
              disabled={!isEditing}
              label='Last Name'
              name='last_name'
              value={EntityData.last_name}
              onChange={handleChange}
              fullWidth
              margin='normal'
              error={!!errors.last_name}
            />
            {errors.last_name && <FormHelperText>{errors.last_name}</FormHelperText>}
          </Grid>
          {/* Last Name */}

          <Grid item xs={4} md={2} alignContent='center'>
            <Typography variant='h6' fontSize={15}>
              Phone Number
            </Typography>
          </Grid>
          <Grid item xs={8} md={4} alignContent='center'>
            <TextField
              disabled={!isEditing}
              label='Phone Number'
              name='phone_no'
              value={EntityData.phone_no}
              onChange={handleChange}
              fullWidth
              margin='normal'
              error={!!errors.phone_no}
            />
            {errors.phone_no && <FormHelperText>{errors.phone_no}</FormHelperText>}
          </Grid>
          {/* Phone */}

          <Grid item xs={4} md={2} alignContent='center' sx={{ px: {md: 4} }}>
            <Typography variant='h6' fontSize={15}>
              Email
            </Typography>
          </Grid>
          <Grid item xs={8} md={4} alignContent='center'>
            <TextField
              disabled={!isEditing}
              label='Email'
              name='email'
              value={EntityData.email}
              onChange={handleChange}
              fullWidth
              margin='normal'
              error={!!errors.email}
            />
            {errors.email && <FormHelperText>{errors.email}</FormHelperText>}
          </Grid>
          {/* Email */}

          <Grid
                item
                xs={4}
                md={2}
                alignContent='center'
              >
                <Typography
                  variant='h6'
                  fontSize={15}
                >
                  Date of Birth
                </Typography>
          </Grid>
          <Grid
            item
            xs={8}
            md={4}
            alignContent='center'
            
          >
            <TextField
              disabled={!isEditing}
              label='Date of Birth'
              name='date_of_birth'
              value={EntityData.date_of_birth}
              onChange={handleChange}
              fullWidth
              margin='normal'
              type='date'
              error={!!errors.date_of_birth}
            />
            {errors.date_of_birth && (
              <FormHelperText>{errors.date_of_birth}</FormHelperText>
            )}
          </Grid>
          {/* DOB */}

          <Grid item xs={4} md={2} alignContent='center' sx={{ px: {md: 4} }}>
            <Typography variant='h6' fontSize={15}>
              Relation
            </Typography>
          </Grid>
          <Grid item xs={8} md={4} alignContent='center'>
            <TextField
              disabled
              label='Relation'
              name='relation'
              value={EntityData.relation}
              fullWidth
              margin='normal' 
            /> 
          </Grid>
          {/* Relation */}

          <Grid item xs={4} md={2} alignContent='center' >
            <Typography variant='h6' fontSize={15}>
              Pan Number
            </Typography>
          </Grid>
          
          <Grid
            item
            xs={8}
            md={4}
            alignContent='center'
            
          >
            <TextField
              disabled
              label='Pan Number'
              name='pancard_no'
              value={EntityData.pancard_no}
              fullWidth
              margin='normal'
            />
            {errors.pancard_no && (
              <FormHelperText>{errors.pancard_no}</FormHelperText>
            )}
          </Grid>
          {/* Pancard Number */}
        </Grid>
        {/* Age Condition */}
        <Grid>
          {age > 60 ? (
            <Typography sx={{ color: 'error.main' }}>
              Your age is {age}, Benefits are not available for age more than 60 years
            </Typography>
          ) : age < 18 ? (
            <Typography sx={{ color: 'error.main' }}>
              Your age is {age}, Please call at helpline for minor beneficiary
            </Typography>
          ) : null}
        </Grid>
        

        {/* Image Display and Update */}
        <Grid container sx={{ mt: '1rem' }}>
          <Grid item xs={12} md={4}>
            <Button
              type='submit'
              variant='contained'
              color='primary'
              disabled={!isEditing}
              onClick={showImageUploadedImage}
            >
              Show Uploaded Image
            </Button>
            {showImage && !newImage &&(
              <Box sx={{ mt: 2 }}>
                {pancardImg ? (
                  <img
                    src={`data:image/png;base64,${pancardImg}`}
                    alt="Uploaded img"
                    style={{ width: '100%', maxWidth: 200, height: 'auto', borderRadius: 4 }}
                  />
                ) : (
                  <Typography variant="body2" color="textSecondary">
                    No image uploaded
                  </Typography>
                )}
            </Box>
            )}
            {newImage && newImage.file_str_base64 && (
              <Box sx={{ mt: 2 }}>
                <img
                  src={`data:image/png;base64,${newImage.file_str_base64}`}
                  alt="Uploaded img"
                  style={{ width: '100%', maxWidth: 200, height: 'auto', borderRadius: 4 }}
                />
              </Box>
            )}
            {isEditing && showImage && (
              <Button component="label" sx={{ mt: 2 }}>
                {pancardImg ? 'Update Image' : 'Upload Image'}
                  <input
                    type='file'
                    accept=".jpeg, .jpg, .png"
                    hidden
                    onChange={(e) => handleImageChange(e)} 
                  />
              </Button>
            )}
          </Grid>
        </Grid>

        
      </CardContent>
    </Card>
  );
};

export default EditCard;
